module.exports = __webpack_public_path__ + "9cc6775dd20b8bc8296022549f907f0a.png";


//////////////////
// WEBPACK FOOTER
// ./shared/images/header/truck-mobile.png
// module id = 975
// module chunks = 2